/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  FreeSoloAutocompleteWithLabel,
  InputWithLabel
} from '@adotel/components'
import { Collapse } from '@material-ui/core'
import Switch from '@material-ui/core/Switch'
import Typography from '@material-ui/core/Typography'
import { useState } from 'react'

import { getTranslate } from '../../../../localization'
import { ModifyAdminConfigLogInput } from '../../../../types/adminConfig'
import useStyles from './index.styles'

type Props = {
  modifyAdminLogInput: ModifyAdminConfigLogInput
  setmodifyAdminLogInput: React.Dispatch<
    React.SetStateAction<ModifyAdminConfigLogInput>
  >
}
export default function FailedLogRetentionTab({
  modifyAdminLogInput,
  setmodifyAdminLogInput
}: Props) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <Typography variant="h4" className={classes.title}>
          {getTranslate('Failed Log Retention')}
        </Typography>
        <Typography className={classes.subtitle}>
          {getTranslate('Configure retention policy for non-admin logs')}
        </Typography>
      </div>
      <div className={classes.section2}>
        <InputWithLabel
          label={getTranslate('Retention Period (Days)')}
          noHelperText
          value={modifyAdminLogInput.failedLogRetention.retentionPeriodDays}
          onChange={(event) => {
            const value = event.currentTarget.value
            if (!/^\d*$/.test(value)) return
            setmodifyAdminLogInput({
              ...modifyAdminLogInput,
              failedLogRetention: {
                ...modifyAdminLogInput.failedLogRetention,
                retentionPeriodDays: Number(value)
              }
            })
          }}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          inputSize={'small'}
          className={classes.input}
        />
      </div>
      <div className={classes.divider} />
      <div>
        <Typography className={classes.fieldLabel}>
          {getTranslate('SMS Notifications')}
        </Typography>
        <div className={classes.toggleRow}>
          <div className={classes.toggleText}>
            <Typography className={classes.fieldLabel}>
              {getTranslate('Enable SMS Alerts')}
            </Typography>
            <Typography variant="h5" className={classes.helperText}>
              {getTranslate('Receive SMS when threshold is reached')}
            </Typography>
          </div>
          <Switch
            color="primary"
            checked={
              modifyAdminLogInput.failedLogRetention.enabledSMSNotifications
            }
            onChange={(event) => {
              setmodifyAdminLogInput({
                ...modifyAdminLogInput,
                failedLogRetention: {
                  ...modifyAdminLogInput.failedLogRetention,
                  enabledSMSNotifications: event.target.checked
                }
              })
            }}
          />
        </div>
        <Collapse
          in={modifyAdminLogInput.failedLogRetention.enabledSMSNotifications}
          timeout={500}
          className={classes.collapse}>
          <InputWithLabel
            label={getTranslate('Maximum Threshold for SMS Notifications')}
            value={
              modifyAdminLogInput?.failedLogRetention.intervalSMSNotifications
            }
            onChange={(event) => {
              const value = event.currentTarget.value
              if (!/^\d*$/.test(value)) return
              setmodifyAdminLogInput({
                ...modifyAdminLogInput,
                failedLogRetention: {
                  ...modifyAdminLogInput.failedLogRetention,
                  intervalSMSNotifications: Number(value)
                }
              })
            }}
            helpertext={getTranslate(
              'Maximum number of SMS notifications to send per security event'
            )}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            inputSize={'small'}
            className={classes.input}
          />
          <div style={{ maxWidth: 320, width: '100%' }}>
            <FreeSoloAutocompleteWithLabel
              name="Hosts"
              label={getTranslate('Phone Numbers')}
              // helpertext={getTranslate('Use E.164 format (e.g., +1234567890)')}
              // placeholder={getTranslate('Enter the Host')}
              // onChange={(_, v: any) => {
              //   setFieldValue('Hosts', v)
              // }}
              options={[]}
              message={''}
              regexPattern={/^(?:\+98|0)?9\d{9}$/}
              size="small"
              value={modifyAdminLogInput.failedLogRetention.mobileNumbers}
              // value={failedLogRetention?.mobileNumbers || []}
              onChange={(_, values: string[]) => {
                setmodifyAdminLogInput({
                  ...modifyAdminLogInput,
                  failedLogRetention: {
                    ...modifyAdminLogInput.failedLogRetention,
                    mobileNumbers: values
                  }
                })
              }}
              inputSize="small"
              // error={(touched.Hosts && !!errors.Hosts) || undefined}
              // onBlur={handleBlur}
              // disabled={isSubmitting}
              className={classes.input}
              limitTags={1}
            />
          </div>
        </Collapse>
      </div>
    </div>
  )
}
